import(/* webpackMode: "eager", webpackExports: ["AttributeCleaner"] */ "/vercel/path1/components/attribute-cleaner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientWrapper"] */ "/vercel/path1/components/client-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/vercel/path1/components/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/vercel/path1/components/theme/theme-provider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path1/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path1/app/globals.css");
